var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [[_c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("".concat(this.status, "_page.form_title"))) + " ")]), _vm.getModuleConfig("".concat(this.status, "_page.form_desc")) ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("".concat(this.status, "_page.form_desc"))) + " ")]) : _vm._e(), _vm.fetching ? _c('div', [_c('Loading')], 1) : _c('div', [_vm.bookings.length ? [_c('ul', _vm._l(_vm.bookings, function (booking, i) {
    return _c('li', {
      key: i,
      staticClass: "s-mb-3"
    }, [_c('Item', {
      attrs: {
        "booking": booking,
        "preset": _vm.preset,
        "show-image": false,
        "field-setting": _vm.fieldSetting,
        "booking-status-mapping": _vm.bookingStatusMapping
      },
      on: {
        "fetch": _vm.fetchBookings
      }
    })], 1);
  }), 0), _c('Pagination', {
    attrs: {
      "total-page": _vm.lastPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })] : _c('div', {
    staticClass: "s-pt-40 s-text-center"
  }, [_c('img', {
    staticClass: "s-mb-3",
    attrs: {
      "src": require("@/assets/images/liff/empty.svg")
    }
  }), _c('p', {
    staticClass: "s-text-gray"
  }, [_vm._v("目前無資料")])])], 2)])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }